import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { OrderBody, OrderResult } from '@oe-backend/types';
import { map } from 'rxjs';
import { ResponseObjectApiInterface } from 'src/app/types/interfaces/api-responses/response-object.api.interface';
import { BaseApiService } from '../../base-api/base-api.service';

export class OrderService extends BaseApiService {
	private http = inject(HttpClient);

	submit(orders: OrderBody[]) {
		return this.http
			.post<ResponseObjectApiInterface<boolean>>(this.apiBaseUrl + '/Orders', orders)
			.pipe(
				map((response: ResponseObjectApiInterface<boolean>) => {
					return response.data;
				}),
			);
	}

	submitByIds(orderIds: string[]) {
		return this.http
			.post<
				ResponseObjectApiInterface<OrderResult>
			>(this.apiBaseUrl + '/Orders/ByItemIds', orderIds)
			.pipe(
				map((response: ResponseObjectApiInterface<OrderResult>) => {
					return response.data;
				}),
			);
	}
}
